
import confirmationDialog from "../dialogs/confirmation-dialog.vue";
import PhotoCropperDialog from "../dialogs/photo-cropper-dialog.vue";
import MenuUploadInfoDialog from "../dialogs/menu-upload-info-dialog.vue";
export default {
  components: { confirmationDialog, PhotoCropperDialog, MenuUploadInfoDialog },
  props: {
    itemDetails: {
      type: Object,
      default: () => {}
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      internalPhoto: null,
      cropImg: null,
      showPhotoCropDialog: false,
      showImageDeletionConfirmationDialog: false,
      showWarningDialog: false,
      dialogContent: "",
      dialogTitle: "",
      MAX_IMAGE_SIZE_IN_BYTES: 2 * 1024 * 1024 // 2MB
    };
  },
  watch: {
    modelValue: {
      handler(val) {
        this.internalPhoto = val;
      },
      deep: true
    }
  },

  async beforeMount() {
    if (this.existingImageURL) {
      this.internalPhoto = await this.dataUrlToFile(this.existingImageURL, "");
    } else {
      this.internalPhoto = this.modelValue;
    }
  },
  computed: {
    existingImageURL() {
      return this.itemDetails.image_url ?? this.itemDetails.image;
    }
  },
  methods: {
    photoChanged(val) {
      if (!val) return;
      const allowedFormats = ["image/png", "image/jpeg", "image/jpg"];
      const fileFormat = val.type;

      if (!allowedFormats.includes(fileFormat)) {
        this.dialogContent =
          "Please note that we only support PNG and JPEG files with a maximum size of 2MB";
        this.dialogTitle = "Invalid File Format";
        this.showWarningDialog = true;
        this.$nextTick(() => {
          this.internalPhoto = null;
          this.$refs.fileupload.$el.querySelector("input").value = null; // Reset input value
          this.$emit("update:modelValue", null);
        });
        return;
      }

      if (
        this.internalPhoto &&
        this.internalPhoto?.size > this.MAX_IMAGE_SIZE_IN_BYTES
      ) {
        this.dialogContent =
          "The uploaded image is over 2 MB. We only support JPEG or PNG files up to 2 MB.";
        this.dialogTitle = "File Size Exceeds 2 MB";
        this.showWarningDialog = true;
        this.$nextTick(() => {
          this.internalPhoto = null;
          this.$refs.fileupload.$el.querySelector("input").value = null; // Reset input value
          this.$emit("update:modelValue", null);
        });
        return;
      } else {
        this.showPhotoCropDialog = true;
      }
    },
    handleReplaceImage() {
      const inputElement =
        this.$refs.fileupload.$el.querySelector('input[type="file"]');
      if (inputElement) {
        inputElement.click();
      }
    },
    handleShowDeleteImageConfirmation() {
      this.showImageDeletionConfirmationDialog = true;
    },
    handleDeleteImage() {
      this.internalPhoto = null;
      this.cropImg = null;
      this.showImageDeletionConfirmationDialog = false;
      this.$emit("update-cropped-photo", {
        cropImg: this.cropImg,
        photo: this.internalPhoto
      });
    },
    handleSaveCroppedImage(img) {
      this.cropImg = img;
      this.showPhotoCropDialog = false;

      this.$emit("update-cropped-photo", {
        cropImg: this.cropImg,
        photo: this.internalPhoto
      });
    }
  }
};
